var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AudioSearch',{attrs:{"icon":_vm.icon,"label":_vm.label,"title":_vm.title,"route":_vm.route,"status":_vm.status,"show-revisor":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }